//TODO: [SLS-11196] Refactor the APIs
import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";
import { AppFeature } from "@modules/app-management/types.ts";
import { Recipe } from "@plugins/recipe/types.ts";

const fetchAppAvailability = (requestData) => {
  return httpClient.get(`/apis/app/get-availability/${requestData.appUuid}`);
};

const updateAppAvailability = (requestData) => {
  return httpClient.post(`/apis/app/update-availability`, requestData);
};

const createApp = (requestData) => {
  return httpClient.post(`/apis/app/create`, requestData);
};

const updateApp = (uuid, requestData) => {
  return httpClient.post(`/apis/app/update/${uuid}`, requestData);
};

const getAppData = (uuid) => {
  return httpClient.get(`/apis/app/get-app-data/${uuid}`);
};

const toggleAppEnable = (uuid) => {
  return httpClient.post(`/apis/app/toggle-enable/${uuid}`);
};

const generateAppSecret = (uuid) => {
  return httpClient.post(`/apis/app/generate-secret/${uuid}`);
};

const getIntegratorAppCategoryAccess = () => {
  return httpClient.get(`/apis/app/integrator/access`);
};

const getIntegratorAppFeature = async (appFeatureId): Promise<ApiResponse<AppFeature>> => {
  return await httpClient.get(`/apis/app/app-feature/get/${appFeatureId}`);
};

const saveIntegratorAppFeature = async (requestData: AppFeature): Promise<ApiResponse<void>> => {
  return await httpClient.post(`/apis/app/app-feature/save`, requestData);
};

const getIntegratorAppFeatureRecipe = async (appFeatureId): Promise<ApiResponse<Recipe[]>> => {
  return await httpClient.get(`/apis/app/app-feature/recipe/get/${appFeatureId}`);
};

export default {
  fetchAppAvailability,
  updateAppAvailability,
  createApp,
  updateApp,
  getAppData,
  toggleAppEnable,
  generateAppSecret,
  getIntegratorAppCategoryAccess,
  getIntegratorAppFeature,
  saveIntegratorAppFeature,
  getIntegratorAppFeatureRecipe,
};
